import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment/environment.service';
import { TermOfUseConsentStatus } from '@mwe/models';
import { REQUEST_APPROVAL_CONDITIONS_OF_USE } from '@mwe/constants';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogWienConditionsOfUseService {
  private http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  resourceUrl: string;
  private consentStatus: TermOfUseConsentStatus;

  constructor() {
    this.resourceUrl = this.environmentService.getApiUrl() + 'api/termofuse/';
  }

  async getRouteForConsentStatus(): Promise<string> {
    await this.getTermOfUseConsentStatus();

    if (this.consentStatus?.consent) {
      return null;
    }
    return `/${REQUEST_APPROVAL_CONDITIONS_OF_USE}`;
  }

  async approve(): Promise<object> {
    return lastValueFrom(this.http.post(this.resourceUrl + 'consent', { consent: true }));
  }

  async decline(): Promise<object> {
    return lastValueFrom(this.http.post(this.resourceUrl + 'consent', { consent: false }));
  }

  private async getTermOfUseConsentStatus(): Promise<void> {
    // only skip backend request when user has approved migration. to recheck backend every time in case of no approval
    if (this.consentStatus?.consent) {
      return;
    }
    this.consentStatus = await lastValueFrom(this.http.get<TermOfUseConsentStatus>(this.resourceUrl + 'status'));
  }
}
